import type { ICellRendererParams, ValueGetterParams } from 'ag-grid-community';

import type { Position } from '../../../types/Position';
import { AgGridCurrency, AgGridSecurity } from '../../AgGrid';
import { baseColumn } from './baseColumn';
import { resolveBlotterAssetIsCurrency } from './resolveBlotterAssetIsCurrency';
import { resolvePositionUnderlying } from './resolvePositionUnderlying';
import type { ColDefFactory, Column } from './types';

type PositionUnderlyingAssetValue = string | undefined;

const defaultCellRendererParams = {
  colorful: true,
  showDescription: false,
};

export const positionUnderlyingAsset: ColDefFactory<Column> = column => ({
  ...baseColumn(column),
  cellRendererParams: {
    ...defaultCellRendererParams,
    ...column.params,
  },
  cellRenderer: (params: ICellRendererParams) => {
    const rendererParams = {
      ...defaultCellRendererParams,
      ...column.params,
      ...params,
    };
    const isCurrency = resolveBlotterAssetIsCurrency(params);

    return isCurrency ? <AgGridCurrency {...rendererParams} /> : <AgGridSecurity {...rendererParams} />;
  },
  valueGetter: ({ data, context }: ValueGetterParams<Position>): PositionUnderlyingAssetValue =>
    resolvePositionUnderlying({
      asset: data?.Asset,
      assetType: data?.AssetType,
      securitiesBySymbol: context.current.securitiesBySymbol,
    }),
});
